import React from 'react';

class CadastrarMovimentacaoForm extends React.Component {

    render() {
        return(
            <div>
                <p id="cadmovimentacao-obrigatorios">* Campos obrigatórios.</p><br /><br />
                <form id="cadmovimentacao-form">
                    <ul class="cadmovimentacao-ghg-lst">
                        <li>
                            <b>GHG: </b>
                            <label>
                                <input type="radio"
                                    name="ghg"
                                    value="true"
                                    checked={ this.props.ghg === true }
                                    onChange={ this.props.changeGhg } /> Sim
                            </label>
                            <label>
                                <input type="radio"
                                    name="ghg"
                                    value="false"
                                    checked={ this.props.ghg === false }
                                    onChange={ this.props.changeGhg } /> Não
                            </label>
                        </li>
                    </ul><br /><br />
                    <span id="cadmovimentacao-data-span"><b>Data*: </b></span>
                    <input type="date"
                        value={ this.props.data }
                        onChange={ this.props.changeData } /><br />
                    <select id="cadmovimentacao-banco-select"
                        value={ this.props.banco }
                        onChange={ this.props.changeBanco }>
                        <option value="">Banco*</option>
                        { this.props.bancos.map((item, i) =>
                            <option key={ i } value={ i }>{ item }</option> ) }
                    </select><br />
                    <select value={ this.props.conta } onChange={ this.props.changeConta }>
                        <option value="">Conta*</option>
                        { this.props.contas.map((item, i) =>
                            <option key={ i } value={ i }>{ item.cod_conta + " - " + item.conta }</option> ) }
                    </select><br />
                    <input type="text"
                        placeholder="Código da Conta"
                        value={ this.props.codigoConta }
                        disabled /><br />
                    <input type="text"
                        placeholder="Código da Movimentação"
                        value={ this.props.codigo }
                        disabled /><br />
                    <input type="text"
                        placeholder="Histórico*"
                        value={ this.props.historico }
                        onChange={ this.props.changeHistorico } /><br />
                    <textarea placeholder="Descrição da Movimentação*"
                        value={ this.props.descricao }
                        onChange={ this.props.changeDescricao }></textarea><br />
                    <span Class="cadmovimentacao-somente-numeros">
                        (Somente valores númericos no campo de Valor.)
                    </span><br /><br />
                    <input type="text"
                        placeholder="Valor (R$)*"
                        value={ this.props.valor }
                        onChange={ this.props.changeValor } /><br />
                    <span id="cadmovimentacao-nf-span"><b>Documento fiscal*: </b></span>
                    <input type="file"
                        id="cadmovimentacao-nf-file"
                        onChange={ this.props.changeNotaFiscal }
                        accept="application/pdf, image/jpeg, image/png, application/xml" />
                    <br /><br />
                    <span id="cadmovimentacao-nf-span"><b>Comprovante de pagamento*: </b></span>
                    <input type="file"
                        id="cadmovimentacao-nf-file"
                        onChange={ this.props.changeComprovante }
                        accept="application/pdf, image/jpeg, image/png, application/xml" />
                    <br /><br /><br />
                    <textarea placeholder="Análise Contábil*"
                        value={ this.props.analiseContabil }
                        onChange={ this.props.changeAnaliseContabil }></textarea><br /><br /><br />
                    <button type="button" id="cadmovimentacao-cadastrar-btn" onClick={ this.props.cadastrar }>
                        Cadastrar
                    </button>
                    <button type="button" id="cadmovimentacao-cancelar-btn" onClick={ this.props.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CadastrarMovimentacaoForm;

